'use client';

import { c as _c } from "react/compiler-runtime";
import { toLowerCase } from 'betterplace-utils';
import classNames from 'classnames';
import { Button, Heading, LinkButton, Modal } from 'design-system/client';
import { useTranslations } from 'next-intl';
import { useCallback, useState } from 'react';
import styles from './Summary.module.css';
import { SummaryProps } from './types';
import I18nHtml from '@/components/I18nHtml';
import DonationAmountSum from '@/donationPages/_dependencies/components/DonationAmountSum';
import { useDonationFormConfig } from '@/donationPages/_dependencies/helpers';
import CodonationSelection from '@/donationPages/iframe/[receiver-type]/[slug]/_dependencies/IFrameForm/CodonationSelection';
function Explanation() {
  const $ = _c(42);
  const t = useTranslations();
  const {
    receiverName,
    wording
  } = useDonationFormConfig();
  const [showWhyModal, setShowWhyModal] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setShowWhyModal(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const openWhyModal = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setShowWhyModal(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hideWhyModal = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("nextjs.donate.summary.headline");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Heading level="heading-xs" className="headline">{t2}</Heading>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("nextjs.donate.summary.description_html");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span>{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("nextjs.donate.codonation_selection.why_modal.open_button");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <LinkButton onClick={openWhyModal} className={styles.explanationMoreInfoButton} type="button">{t6}</LinkButton>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <p>{t5}{" "}{t7}</p>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("nextjs.donate.codonation_selection.why_modal.headline");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("nextjs.donate.codonation_selection.why_modal.close_button");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("nextjs.donate.codonation_selection.why_modal.close_button");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <Button kind="primary" size="small" onClick={hideWhyModal} type="button" className={styles.closeModalButton}>{t11}</Button>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== wording) {
    t13 = toLowerCase(wording);
    $[25] = wording;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const t14 = `donate.codonation_selection.why_modal.${t13}_html`;
  let t15;
  if ($[27] !== receiverName) {
    t15 = {
      receiver_name: receiverName
    };
    $[27] = receiverName;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t14 || $[30] !== t15) {
    t16 = <I18nHtml as="div" i18nKey={t14} options={t15} />;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== showWhyModal || $[33] !== t10 || $[34] !== t12 || $[35] !== t16 || $[36] !== t9) {
    t17 = <Modal id="donation-summary-modal" onClose={hideWhyModal} isOpen={showWhyModal} title={t9} closeText={t10} customActions={t12}>{t16}</Modal>;
    $[32] = showWhyModal;
    $[33] = t10;
    $[34] = t12;
    $[35] = t16;
    $[36] = t9;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t17 || $[39] !== t3 || $[40] !== t8) {
    t18 = <>{t3}{t8}{t17}</>;
    $[38] = t17;
    $[39] = t3;
    $[40] = t8;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  return t18;
}
function Summary(props) {
  const $ = _c(17);
  const t = useTranslations();
  const {
    showCodonation
  } = useDonationFormConfig();
  if (!showCodonation) {
    return null;
  }
  let t0;
  if ($[0] !== props.explanation) {
    t0 = props.explanation || <Explanation />;
    $[0] = props.explanation;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <td className={classNames(styles.cell, styles.codonationSelectionCell)}><CodonationSelection /></td>;
    t2 = classNames(styles.cell, styles.codonationAmountSumCell);
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span>+ </span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <tr className={styles.row}>{t1}<td className={t2}><span className={styles.codonationAmountSumContent}>{t3}<DonationAmountSum precision={2} fields={["codonation_cents"]} /></span></td></tr>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classNames(styles.cell, styles.totalDonationAmountSumCell);
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t("nextjs.donate.summary.total");
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <span>{t6}</span>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <DonationAmountSum precision={2} fields={["amount_cents", "codonation_cents"]} />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7) {
    t9 = <div className={styles.donationSummaryContainer}><table className={styles.table}><tbody>{t4}<tr className={styles.row}><td colSpan={2} className={t5}><strong className={styles.totalDonationAmountSumContent}>{t7}{" "}{t8}</strong></td></tr></tbody></table></div>;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t0 || $[15] !== t9) {
    t10 = <>{t0}{t9}</>;
    $[14] = t0;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}
export default Summary;